module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "nav-item float-left logo",
    style: (("background-image: url(" + (require('@/assets/images/logo_chinese.svg')) + ")")),
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-item float-right icon_menu",
    on: {
      "click": function($event) {
        _vm.$emit('click-menu')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-029e69d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/nav.vue
// module id = 675
// module chunks = 57